import { inject, Injectable } from '@angular/core';
import { ApiServiceBase } from '@twist/core';
import { firstValueFrom } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import {
  CreateOrganizationCommand,
  GetOrganizationQueryResult,
  GetOrganizationsQueryResult,
  Organization,
  OrganizationsBackboneService, UpdateOrganizationCommand
} from '@twist/backbone-api-services/ciam';

@Injectable({ providedIn: 'root' })
export class OrganizationManagementService extends ApiServiceBase {
  private backboneService = inject(OrganizationsBackboneService);

  getOrganization = (organizationKey: string): Promise<GetOrganizationQueryResult> => {
    return new Promise<GetOrganizationQueryResult>((resolve, reject) => {
      firstValueFrom(
        this.backboneService.getOrganizationDetails(organizationKey)
      )
        .then((result) => {
          resolve(result);
        })
        .catch(async (err: HttpErrorResponse | null) => {
          await this.handleErrorAndReject('', err, reject);
        });
    });
  };

  getOrganizations = (): Promise<GetOrganizationsQueryResult> => {
    return new Promise<GetOrganizationsQueryResult>((resolve, reject) => {
      firstValueFrom(
        this.backboneService.getOrganizations()
      )
        .then((result) => {
          resolve(result);
        })
        .catch(async (err: HttpErrorResponse | null) => {
          await this.handleErrorAndReject('', err, reject);
        });
    });
  };

  /*  createOrganization = (command: Organization): Promise<CreateOrganizationCommandResult> => {
      return new Promise<Organization>((resolve, reject) => {
        firstValueFrom(
          this.backboneService.createOrganization(command)
        )
          .then((result.) => {
            resolve(result.);
          })
          .catch(async (err: HttpErrorResponse | null) => {
            await this.handleErrorAndReject('', err, reject);
          });
      });
    };*/

  createOrganization = (
    command: CreateOrganizationCommand): Promise<Organization> => {
    return new Promise<Organization>((resolve, reject) => {
      firstValueFrom(this.backboneService.createOrganization(
        command
      ))
        .then((response) => {
          if (response.result) {
            resolve(response.result);
          } else {
            reject();
          }
        })
        .catch(async (err: HttpErrorResponse | null) => {
          await this.handleErrorAndReject('', err, reject);
        });
    });
  };

  updateOrganization = (
    organizationKey: string,
    command: UpdateOrganizationCommand // Assuming this is a valid DTO for updating an organization
  ): Promise<Organization> => {
    return new Promise<Organization>((resolve, reject) => {
      firstValueFrom(
        this.backboneService.updateOrganization(organizationKey, command) // Assuming `updateOrganization` exists in backboneService
      )
        .then((response) => {
          if (response.result) {
            resolve(response.result);
          } else {
            reject();
          }
        })
        .catch(async (err: HttpErrorResponse | null) => {
          await this.handleErrorAndReject('', err, reject);
        });
    });
  };


  deleteOrganization = (organizationKey: string): Promise<void> => {
    return new Promise<void>((resolve, reject) => {
      firstValueFrom(
        this.backboneService.deleteOrganization(organizationKey) // Assuming `deleteOrganization` exists in backboneService
      )
        .then(() => {
          resolve();
        })
        .catch(async (err: HttpErrorResponse | null) => {
          await this.handleErrorAndReject('', err, reject);
        });
    });
  };

}
